import React, { useState } from "react";
import { IoIosHelpCircleOutline } from "react-icons/io";

const Tooltip = (props) => {
  const {
    tip,
    position,
    height,
    width,
    textSize,
    textColor,
    background,
    border,
    borderThickness,
    icon,
    helpPointer,
  } = props;
  const [isActive, setIsActive] = useState(false);

  // let newPosition;
  // if (position === "top") newPosition = "-top-12 sm:-top-14";
  // if (position === "bottom") newPosition = "-bottom-24 sm:-bottom-24";
  // if (position === "left") newPosition = "left-24";
  // if (position === "right") newPosition = "right-24";
  // if (!position) newPosition = "bottom-20";

  return (
    <div
      className={`flex justify-center items-center relative ${
        helpPointer ? "cursor-help" : ""
      }`}
      onMouseEnter={() => {
        setIsActive(!isActive);
      }}
      onMouseLeave={() => {
        setIsActive(!isActive);
      }}
    >
      {props.children}{" "}
      {icon && (
        <div className="px-1 text-sm mt-2">
          <IoIosHelpCircleOutline />
        </div>
      )}
      {isActive && (
        <div
          className={`
          ${height}
          ${width || `w-60`} 
          ${position} 
          ${textSize} 
          ${textColor} 
          ${background || `bg-slate-100`} 
          ${border || `border-slate-300`} 
          ${borderThickness || `border-2`} 
          min-h-10 rounded-2xl flex justify-center items-center absolute break-words px-2 py-1 z-50`}
        >
          {tip}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
